import { render, staticRenderFns } from "./Clients.vue?vue&type=template&id=910280c6&"
import script from "./Clients.vue?vue&type=script&lang=ts&"
export * from "./Clients.vue?vue&type=script&lang=ts&"
import style0 from "./Clients.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports